// extracted by mini-css-extract-plugin
export default {"feeds":"feeds_feeds__xlDCs","container":"feeds_container__phxLX"};